import { gql } from '@apollo/client';

export const GET_USER_TWILIO_STATE = gql`
  query GetUserTwilioState($id: ID!) {
    userTwilioState(id: $id) {
      ... on UserTwilioState {
        status
        __typename
      }
      ... on UserTwilioStateError {
        __typename
        ErrorMessage: message
        responseType
      }
      ... on NotFoundError {
        message
        responseType
        __typename
      }
      ... on InputValidationFailure {
        message
        responseType
        invalidFields {
          fieldName
          reason
          __typename
        }
        __typename
      }
      ... on AuthorizationFailure {
        message
        responseType
        __typename
      }
      __typename
    }
  }
`;
